import { useCallback, useEffect } from 'react';
import { publicEventsAPIService } from 'js/services/publicEventsAPI.service';

/**
 * Event fires when there is any error from within the Geofencing process.
 * @memberOf Playtech.API.events
 * @event geofencing-error
 * @type {callback}
 * @param {object} detials
 * @param {number} details.error - Generic error object, if available.
 * @param {number} details.errorCode - Error code as reported by the geolocation provider.
 * @param {number} details.message - Error message as reported by the geolocation provider.
 * @param {number} details.response - Response object as reported by PAS.
 * @example Playtech.on('geofencing-error', ({ error, errorCode, message, response }) => { ... });
 */
export const GEOFENCING_ERROR = 'geofencing-error';

export const useOnGeofencingError = (eventTarget: EventTarget): void => {
    const triggerGeofencingErrorEvent = useCallback((detail: {
        error?: any;
        errorCode?: number | string;
        response?: any;
        message?: string;
    }) => {
        const event = new CustomEvent(GEOFENCING_ERROR, { detail });

        eventTarget.dispatchEvent(event);
    }, [eventTarget]);

    useEffect(() => {
        publicEventsAPIService.on('geofencing-error', triggerGeofencingErrorEvent);

        return () => {
            publicEventsAPIService.off('geofencing-error', triggerGeofencingErrorEvent);
        };
    }, [triggerGeofencingErrorEvent]);
};
